'use client';

import a__default, { memo, forwardRef } from "react";
import { Text } from "../Text/Text.js";
import { Sparkle } from "../../../react-icons.js";
import { classNames } from "../../utils/styles/classNames.js";
import { logError } from "../../utils/console/logError.js";
import { variants, roundness, spacing, base, content, aiIcon } from "./Badge.css.js";
import { BADGE_LABEL_MAX } from "./utils/constants.js";
import { defaultProps } from "./Badge.defaultProps.js";
function BadgeComponent({
  label,
  variant,
  a11yLabel,
  emphasis: emphasisProp,
  icon: Icon,
  iconStyle,
  dataQa,
  roundness: roundnessProp,
  className,
  ...props
}, ref) {
  const isLongLabel = label.length > BADGE_LABEL_MAX;
  const isAi = variant === "ai";
  const roundness$1 = roundnessProp || defaultProps.roundness;
  const emphasis = emphasisProp || defaultProps.emphasis;
  if (!label || !variant) {
    logError(`Missing required props for Badge`, {
      label,
      variant
    });
    return null;
  }
  const renderIcon = () => {
    if (!isAi && !Icon) return null;
    if (isAi) {
      return /* @__PURE__ */ a__default.createElement(a__default.Fragment, null, /* @__PURE__ */ a__default.createElement(
        Sparkle,
        {
          className: aiIcon,
          fill: emphasis === "medium" ? "url(#ai-gradient)" : "currentColor",
          size: "sm"
        }
      ), emphasis === "medium" && /* @__PURE__ */ a__default.createElement(
        "svg",
        {
          "aria-hidden": "true",
          focusable: "false",
          style: { width: 0, height: 0, position: "absolute" }
        },
        /* @__PURE__ */ a__default.createElement(
          "linearGradient",
          {
            id: "ai-gradient",
            x1: "9.472125%",
            x2: "141.1675%",
            y1: "120.160625%",
            y2: "50.119125%"
          },
          /* @__PURE__ */ a__default.createElement("stop", { offset: "0%", stopColor: "#2A4ECC" }),
          /* @__PURE__ */ a__default.createElement("stop", { offset: "40%", stopColor: "#DA0B78" }),
          /* @__PURE__ */ a__default.createElement("stop", { offset: "100%", stopColor: "#FF4AA9" })
        )
      ));
    }
    return Icon && /* @__PURE__ */ a__default.createElement(Icon, { filled: iconStyle === "filled", size: "sm" });
  };
  return /* @__PURE__ */ a__default.createElement(
    "span",
    {
      ...props,
      className: classNames(
        className,
        base,
        spacing[roundness$1][Icon || isAi ? "withIcon" : "default"],
        roundness[roundness$1],
        variants[emphasis][variant]
      ),
      "data-qa": dataQa,
      ref,
      title: isLongLabel ? label : void 0
    },
    renderIcon(),
    a11yLabel && /* @__PURE__ */ a__default.createElement(Text, { variant: "help-text.xs", visuallyHidden: true }, a11yLabel),
    /* @__PURE__ */ a__default.createElement(
      Text,
      {
        "aria-hidden": a11yLabel ? "true" : void 0,
        className: content,
        variant: "help-text.xs"
      },
      label
    )
  );
}
const Badge = /* @__PURE__ */ memo(forwardRef(BadgeComponent));
export {
  Badge
};
